<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="white"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />
     <v-btn
             color="primary"
             text
              @click="logout"
            >
              Cerrar sesión
            </v-btn>
  </v-app-bar>
</template>

<script>
  // Utilities
  export default {
    name: 'DashboardCoreAppBar',
    data: () => ({
    }),
    methods: {
      logout: function () {
        this.$session.destroy()
        this.$router.push('/login')
        this.$swal({
          text: 'SE HA FINALIZADO SU SESIÓN',
          showConfirmButton: true,
          showCloseButton: false,
          showCancelButton: false,
          icon: 'success',
        })
      },
    },
  }
</script>
